package diana.soleil.design.iraniancanadienbazzar.core.designsystem.component

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.size
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.unit.Dp
import coil3.compose.AsyncImage
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.theme.AppTheme

/**
 * The app-wide PERSON avatar: the member's photo when they have one, otherwise their initial on the
 * stable per-identity color from [avatarColorFor] — so the same person looks the same on the Home
 * rail, people cards, the map card and the profile screen. While a photo loads (or if it errors)
 * the colored initial stays visible underneath, so the circle is never empty.
 * ([AppAvatar] stays the generic soft-chip variant used for businesses/inbox rows.)
 */
@Composable
fun PersonAvatar(
    id: String,
    name: String,
    modifier: Modifier = Modifier,
    photoUrl: String? = null,
    size: Dp = AppTheme.sizes.avatarMd,
    textStyle: TextStyle = AppTheme.typography.headlineMd,
    contentDescription: String? = null,
) {
    Box(
        modifier = modifier
            .size(size)
            .clip(AppTheme.shapes.pill)
            .background(avatarColorFor(id)),
        contentAlignment = Alignment.Center,
    ) {
        Text(
            text = name.trim().take(1).uppercase(),
            style = textStyle,
            color = AppTheme.colors.onPrimary,
        )
        if (!photoUrl.isNullOrBlank()) {
            AsyncImage(
                model = photoUrl,
                contentDescription = contentDescription,
                contentScale = ContentScale.Crop,
                modifier = Modifier.fillMaxSize(),
            )
        }
    }
}
